import * as React from 'react'

import { useData, useHandlers } from './hooks'
import { WWMXGrid } from '@user/components/xGrid'
import { LoadingSpinner } from '@sales-center/components'

export function ActivitySummaryTable() {
  const { apiRef, prefsLoading, paginationState, ...rest } = useData()

  const { handlePaginationModelChange, onChangeSortModel } = useHandlers({
    apiRef,
  })

  if (prefsLoading) return <LoadingSpinner />

  return (
    <WWMXGrid
      {...rest}
      apiRef={apiRef}
      paginationModel={paginationState}
      onPaginationModelChange={handlePaginationModelChange}
      onSortModelChange={onChangeSortModel}
    />
  )
}
